import API from "shared/services/Api";
import { IReferral } from "shared/types/Referral";

export const sendReferral = async (data: IReferral, userId: string) =>
  API.post(`oc/referrals/referral?id=${userId}`, data);
